// @flow
import isEmpty from 'lodash/isEmpty'
import join from 'lodash/join'
import reject from 'lodash/reject'
import * as React from 'react'
import type { TeamDetails } from 'types/team_details'
import Flex from 'ui/atoms/Flex'
import FormContainer from 'ui/atoms/FormContainer'
import { getImageUrl } from 'utils/helpers'

type Props = {
  team: ?TeamDetails,
}

function FormHeaderTeam({ team }: Props): React.Node {
  const [hasImageFallback, setHasImageFallback] = React.useState(false)

  const onImageError = React.useCallback(() => {
    setHasImageFallback(true)
  }, [])

  return (
    <div className="border-b p-4">
      <FormContainer noPaddingTop>
        <div className="sm:mx-6">
          <Flex align="start" justify="between">
            {team?.image && !hasImageFallback ? (
              <div className="h-12 !w-[fit-content] max-w-lg">
                <img
                  alt={`${team?.name || ''} logo`}
                  className="h-full !w-auto"
                  onError={onImageError}
                  src={getImageUrl(team?.image)}
                />
              </div>
            ) : (
              team?.name && (
                <h5 className="text-lg font-semibold text-txt-emphasis">
                  {team.name}
                </h5>
              )
            )}
            <div>
              {(team?.address_street_1 || team?.address_street_2) && (
                <p className="text-right text-sm">
                  {join(
                    reject(
                      [team?.address_street_1, team?.address_street_2],
                      isEmpty
                    ),
                    ', '
                  )}
                </p>
              )}
              {(team?.address_city ||
                team?.address_state ||
                team?.address_zip) && (
                <p className="text-right text-sm">
                  {join(
                    reject(
                      [
                        team?.address_city,
                        team?.address_state,
                        team?.address_zip,
                      ],
                      isEmpty
                    ),
                    ', '
                  )}
                </p>
              )}
              {team?.contact_email && (
                <a
                  className="hover:no-underline"
                  href={`mailto:${team.contact_email}`}
                >
                  <p className="text-right text-sm">{team.contact_email}</p>
                </a>
              )}
            </div>
          </Flex>
        </div>
      </FormContainer>
    </div>
  )
}

export default FormHeaderTeam
